const VitalitySVG = ({iconSize = 24}) => (
    <svg width={iconSize} height={iconSize} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7" r="7" fill="#f41c5e"/>
    </svg>
);

export default VitalitySVG;